export const bankAccountFormFields = {
  ACCOUNT_TYPE: 'account_type',
  AGENCY: 'agency',
  AGENCY_DIGIT: 'agency_digit',
  BANK: 'bank',
  BANK_ACCOUNT: 'bank_account',
  BANK_ACCOUNT_DIGIT: 'bank_account_digit',
};
